var render = function (_h,_vm) {var _c=_vm._c;return _c('b-nav-item',{staticClass:"p-0 px-md-3",class:[
    { 'nav-item-special mx-auto mx-md-0': _vm.props.isSpecial },
    _vm.props.extraCssClass ? _vm.props.extraCssClass : ''
  ],attrs:{"to":_vm.props.to,"exact":_vm.props.to === '/' ? true : false}},[_c('span',[_vm._v(_vm._s(_vm.props.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }